var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSettingsButtonIcon = function SvgSettingsButtonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#settings_button_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 18,
    r: 14.5,
    fill: "#373737",
    stroke: "url(#settings_button_icon_svg__b)",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("mask", {
    id: "settings_button_icon_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M27.044 13.933a2 2 0 0 1-.732 2.732l-.866.5a6.5 6.5 0 0 1 .002 1.67l.864.5a2 2 0 0 1 .732 2.732l-.5.866a2 2 0 0 1-2.732.732l-.864-.5A6.5 6.5 0 0 1 21.5 24v1a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-1a6.6 6.6 0 0 1-1.447-.835l-.865.5a2 2 0 0 1-2.732-.732l-.5-.866a2 2 0 0 1 .732-2.732l.865-.5a6.5 6.5 0 0 1 0-1.671l-.865-.5a2 2 0 0 1-.732-2.731l.5-.866a2 2 0 0 1 2.732-.732l.864.499a6.5 6.5 0 0 1 1.448-.835V11a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v1a6.6 6.6 0 0 1 1.447.834l.865-.5a2 2 0 0 1 2.732.733z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.312 16.665.65 1.126zm.732-2.732-1.126.65zm-1.598 3.232-.65-1.126a1.3 1.3 0 0 0-.639 1.294zm.002 1.67-1.29-.166a1.3 1.3 0 0 0 .64 1.293zm1.596 3.232 1.126.65zm-.5.866-1.126-.65zm-3.596.233.65-1.126a1.3 1.3 0 0 0-1.44.093zM21.5 24l-.5-1.2a1.3 1.3 0 0 0-.8 1.2zm0 1h-1.3zm-2 2v-1.3zm-1 0v1.3zm-2-2h1.3zm0-1h1.3A1.3 1.3 0 0 0 17 22.802zm-1.447-.835.788-1.034a1.3 1.3 0 0 0-1.438-.091zm-.865.5.65 1.126zm-2.732-.732-1.126.65zm-.5-.866 1.126-.65zm.732-2.732.65 1.126zm.865-.5.65 1.126a1.3 1.3 0 0 0 .64-1.294zm0-1.671 1.288.167a1.3 1.3 0 0 0-.639-1.293zm-.865-.5-.65 1.127zm3.364-3.83-.65 1.126a1.3 1.3 0 0 0 1.44-.093zm1.448-.835.499 1.2a1.3 1.3 0 0 0 .8-1.2zm0-.999h1.3zm2-2v1.3zm1 0V7.7zm2 2h1.3zm0 1h-1.3c0 .523.315.996.799 1.198zm1.447.834-.788 1.034a1.3 1.3 0 0 0 1.438.092zm.865-.5.65 1.127zm2.732.733 1.126-.65zm.418 4.724a3.3 3.3 0 0 0 1.208-4.508l-2.252 1.3a.7.7 0 0 1-.256.956zm-.866.5.866-.5-1.3-2.252-.866.5zm.641.711a7.8 7.8 0 0 0-.002-2.005l-2.578.336c.058.44.06.89.001 1.336zm.225-.793-.864-.5-1.3 2.253.864.499zm1.208 4.508a3.3 3.3 0 0 0-1.208-4.508l-1.3 2.252a.7.7 0 0 1 .256.956zm-.5.866.5-.866-2.252-1.3-.5.866zm-4.508 1.208a3.3 3.3 0 0 0 4.508-1.208l-2.252-1.3a.7.7 0 0 1-.956.256zm-.864-.5.864.5 1.3-2.252-.864-.499zm-.299.91a7.8 7.8 0 0 0 1.738-1.002l-1.578-2.066A5.2 5.2 0 0 1 21 22.8zm-1.8-1.2V25h2.6v-1zm0 .999a.7.7 0 0 1-.7.7v2.6a3.3 3.3 0 0 0 3.3-3.3zm-.7.7h-1v2.6h1zm-1 0a.7.7 0 0 1-.7-.7h-2.6a3.3 3.3 0 0 0 3.3 3.3zm-.7-.7v-1h-2.6v1zm-2.699-.245q.44.254.898.445l1.003-2.399a5 5 0 0 1-.601-.298zm-.835-.556q.395.301.835.556l1.3-2.252a5 5 0 0 1-.559-.372zm.573.592.865-.5-1.3-2.251-.865.499zm-4.508-1.208a3.3 3.3 0 0 0 4.508 1.208l-1.3-2.252a.7.7 0 0 1-.956-.256zm-.5-.866.5.866 2.252-1.3-.5-.866zm1.208-4.508a3.3 3.3 0 0 0-1.208 4.508l2.252-1.3a.7.7 0 0 1 .256-.956zm.865-.5-.865.5 1.3 2.252.866-.5zm-.64-.712a7.8 7.8 0 0 0 .001 2.006l2.579-.336a5.2 5.2 0 0 1-.002-1.336zm-.225.794.864.499 1.3-2.252-.864-.499zM9.83 13.283a3.3 3.3 0 0 0 1.208 4.508l1.3-2.252a.7.7 0 0 1-.256-.956zm.5-.866-.5.866 2.252 1.3.5-.866zm4.508-1.208a3.3 3.3 0 0 0-4.508 1.208l2.252 1.3a.7.7 0 0 1 .956-.256zm.864.5-.864-.5-1.3 2.252.864.499zm.299-.91c-.615.256-1.2.591-1.738 1.002l1.578 2.066A5.2 5.2 0 0 1 17 13.2zM17.8 12V11h-2.6v1zm0-.999a.7.7 0 0 1 .7-.7V7.7a3.3 3.3 0 0 0-3.3 3.3zm.7-.7h1V7.7h-1zm1 0a.7.7 0 0 1 .7.7h2.6a3.3 3.3 0 0 0-3.3-3.3zm.7.7v1h2.6v-1zm2.7.245a8 8 0 0 0-.899-.445l-1.003 2.398q.306.128.602.298zm.835.555a8 8 0 0 0-.835-.555l-1.3 2.252q.295.17.559.371zm-.573-.591-.865.5 1.3 2.251.865-.5zm4.508 1.208a3.3 3.3 0 0 0-4.508-1.208l1.3 2.252a.7.7 0 0 1 .956.256zm.5.866-.5-.866-2.252 1.3.5.866z",
    mask: "url(#settings_button_icon_svg__c)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 18,
    r: 3,
    stroke: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "settings_button_icon_svg__b",
    x1: 19,
    x2: 19,
    y1: 3,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "settings_button_icon_svg__a",
    width: 38,
    height: 38,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7179_22441"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7179_22441",
    result: "shape"
  })))));
};
export default SvgSettingsButtonIcon;